import {api, RequestParam} from "@/shared/api";
import * as Button from "@/shared/utils/button";
import {TaskDropdown} from "@/shared/task/taskDropdown";
import * as BootstrapModal from "@/shared/ui/bootstrapModal";
import {Task} from "@/shared/timr";

export interface SetTaskDialogConfig {
	container: JQuery;
}

export class SetTaskDialog {

	public static EVENT_TASK_SET = "taskSet";

	private dialog: BootstrapModal.Modal;
	private taskDropdown: TaskDropdown;
	private params: RequestParam[];

	constructor(public config: SetTaskDialogConfig) {
		this.init();
	}

	private init() {
		this.dialog = new BootstrapModal.Modal({
			message: this.config.container,
			buttons: [{
				text: "dialog.cancel",
				css: "cancelButton btn-default"
			}],
			onClose: () => {
				$(this.taskDropdown).unbind();
				Button.resetLoading(this.dialog.getButtons("cancelButton"));
			},
			onOpen: () => {
				this.bindTaskDropdown();
				$("#projectTimeSetTaskQuery").focus();
			}
		});
		this.taskDropdown = new TaskDropdown({
			rootElement: $("#projectTimeSetTaskDropdown"),
			allowSelectionOfNotBookable: false,
			hideInactive: true,
			clearable: true
		}, {
			loadRootNodesURL: "reports/loadAllTasks.json",
			loadSubNodesURL: "reports/treeLoad.json",
			filterNodesURL: "reports/filterTasks.json"
		});
	}

	public show(params: RequestParam[], recordCount: number) {
		this.params = params;

		// Update dialog title with record count
		this.dialog.setTitle(messages.withArguments("setTaskDialog.title", recordCount));

		this.config.container.find(".fancytree-node").removeClass("fancytree-active");
		this.taskDropdown.queryIfNeeded();
		this.dialog.show();
	}

	private bindTaskDropdown() {
		this.setTaskDropdownLoadingState(false);
		$(this.taskDropdown).on(TaskDropdown.EVENT_SELECTED, (e, task: Task) => {
			$(this.taskDropdown).unbind();

			this.setTaskDropdownLoadingState(true);
			this.setTask(task.id);
		});
	}

	private setTaskDropdownLoadingState(setLoading: boolean) {
		const container = this.config.container.find("ul.fancytree-container");
		const inputFields = this.config.container.find("input");
		const cancelButton = this.dialog.getButtons("cancelButton");

		inputFields.prop("disabled", setLoading);
		container.toggleClass("ui-fancytree-disabled", setLoading);
		if (setLoading) {
			Button.setLoading(cancelButton);
		} else {
			Button.resetLoading(cancelButton);
		}
	}

	private setTask(taskId: number) {
		if (this.params && taskId) {
			this.params.push({name: "newTaskId", value: taskId});

			api("reports/bulkProjectTimesSetTask.json")
				.post(this.params)
				.done((data) => {
					this.bindTaskDropdown();
					$(this).triggerHandler(SetTaskDialog.EVENT_TASK_SET, [data]);
				})
				.always(() => {
					Button.resetLoading($(".modal-footer").find(`button[data-dismiss="modal"]`));
					this.dialog.close();
				});
		}
	}
}
